export default __webpack_public_path__ + "static/media/banner_illustration_1.6c111041.png";